import RTE from '../components/RTE';
import ShareThis from '../components/ShareThis';

export default class StaticArticle {
  constructor(section) {
    this.el = section.el;
    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    this.shareThisEl = this.el.querySelector('[data-sharethis]');

    if (this.shareThisEl) {
      this.sharethis = new ShareThis(this.shareThisEl);
    }
  }

  onSectionUnload() {
    this.rtes.forEach(rte => rte.unload());

    if (this.shareThis) {
      this.sharethis.unload();
    }
  }
}
